export const GOOGLE_MAPS_API_KEY = "AIzaSyDeSCNK7ezDQiDcM3Yh-fjdD7QcQVdgnoE";
export const SECRET = "test-api-secret-key";
